export const PEOPLE_RANKING_GET = "PEOPLE_RANKING_GET";
export const CLOSED_ORDERS_FILTER_ASC = "CLOSED_ORDERS_FILTER_ASC";
export const CLOSED_ORDERS_FILTER_DESC = "CLOSED_ORDERS_FILTER_DESC";
